export const SCALE = {
  not_meet_expectactions: [0, 12],
  below_expectations: [13, 37],
  meet_expectations: [38, 62],
  exceeds_expectations: [63, 87],
  outstanding: [88, 100],
}
